import emailMisspelled, { top100 } from 'email-misspelled';

export function emailMisspell(
    value,
    firstSuggestionOnly = true,
    options = { domains: [], maxMisspelled: 2 }
) {
    if (!value) {
        return null;
    }

    const emailChecker = emailMisspelled({
        maxMisspelled: options.maxMisspelled,
        domains: options.domains.length ? options.domains : top100
    });

    if (firstSuggestionOnly) {
        const suggestions = emailChecker(value);

        return suggestions && suggestions.length
            ? suggestions[0].corrected
            : null;
    }

    return emailChecker(value);
}
